import type { DraftSummary } from "../api";
import { shortDate, who } from "../format";

const KIND: Record<DraftSummary["kind"], string> = { new: "", reply: "Réponse · ", forward: "Transfert · " };

export function DraftList({ drafts, selected, loading, onOpen }: {
  drafts: DraftSummary[];
  selected?: string;
  loading: boolean;
  onOpen: (d: DraftSummary) => void;
}) {
  if (!loading && drafts.length === 0) return <div class="empty">Aucun brouillon.</div>;
  return (
    <div class="threads" role="list">
      {drafts.map((d) => (
        <button key={d.id} role="listitem" class={`thread no-pick${selected === d.id ? " active" : ""}`} onClick={() => onOpen(d)}>
          <span class="who">{d.to.length ? `À : ${d.to.map(who).join(", ")}` : "(sans destinataire)"}</span>
          <span class="meta when">{shortDate(d.updatedAt)}</span>
          <span class="subject">{KIND[d.kind]}{d.subject || "(sans objet)"}</span>
          <span class="snippet">{d.snippet || (d.from ? `De ${d.from}` : "Brouillon")}</span>
        </button>
      ))}
      {loading && <div class="empty">Chargement…</div>}
    </div>
  );
}
